export default __webpack_public_path__ + "static/9-2a913cad9731c870ebd13cb1e940c753.jpg";